module.exports = __webpack_public_path__ + "img/undraw_business_shop_qw5t.fcba9e66.svg";